import React, { Component, Fragment } from "react";
//import compose from 'recompose/compose';
import { Badge, Button, Card, CardBody, CardFooter, CardHeader, Col, Collapse, Fade, Row, FormGroup, Label, Input } from 'reactstrap';
import config from '../../config';
import Moment from 'moment';
import { withStyles } from "@material-ui/core/styles";
import { connect } from 'react-redux';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import { userActions, alertActions, orderActions } from "../../_actions";
import { apiConstants } from '../../_constants/api.constants';


const styles = theme => ({
    error: {
        color: 'red',
    },
    root: {
        margin: 0,
        padding: theme.spacing(2),
        backgroundColor: "#269abc",
        color: '#fff'
    },
    contentRoot: {
        padding: theme.spacing(2),
        fontSize: 14,
        width: 600
      },
      actionRoot: {
        margin: 0,
        padding: theme.spacing(1)
      }

});

class UsersDetail extends Component {

    constructor(props) {
        super(props);
        this.toggleAccordion = this.toggleAccordion.bind(this);
        this.state = {
            accordion: [false, false, false,false],
            editAddressPopup : false,
            triggerEditAddress : false,
            userDetails : props.userData,
            totalPaid : 0,
            avgOrder: 0,
            isDate : false,
            lastOrder : new Date(),
            currentOrder : {}
        };
    }

    //GET USER PAYMENT HISTORY
    componentDidMount(){
      const { dispatch } = this.props;
      var obj = {}
      obj.userId = this.state.userDetails._id;
      dispatch(userActions.stripeAccount(apiConstants.USER_PAYMENT_HISTORY, obj));
      obj.isAdminQuery = true;
      dispatch(orderActions.getAllOrders(apiConstants.GET_USER_ACTIVE_ORDER, obj));
    }

    //default react function to check incoming data
    componentWillReceiveProps(props){
        const { siteConstants } = this.props.language;
        const { dispatch } = this.props;

        //set default addresss
        if( props.setDefaultAddress !== undefined &&
            props.setDefaultAddress.updated !== undefined &&
            props.setDefaultAddress.updated === true ){
                if( this.state.triggerEditAddress === true){

                    dispatch(alertActions.success(siteConstants.GEN_ADDRESS_SET_SUCCESFULLY));

                    this.setState({
                        triggerEditAddress : false,
                        editAddressPopup : false,
                        userData : '',
                        defaultAddress : '',
                        userDetails : props.setDefaultAddress.data.data.data
                    })

                    setTimeout(function(){
                        dispatch(alertActions.clear());
                     }, 3000);
                }
        }

        //get user order history related info
        if(props.updatedAccountDetails !== undefined){
          if( props.updatedAccountDetails !== undefined &&
              props.updatedAccountDetails.updatedAccountDetails !== undefined &&
              props.updatedAccountDetails.updatedAccountDetails.data !== undefined &&
              props.updatedAccountDetails.updatedAccountDetails.data.data !== undefined){
                var data = props.updatedAccountDetails.updatedAccountDetails.data.data;
                this.setState({ totalPaid : parseFloat(data?.totalPaid?.toFixed(2)), avgOrder : parseFloat(data?.avgOrder?.toFixed(2))})
                if(data.date !== undefined){
                  var date = new Date(data.date);
                  var today = new Date();
                  var a = Moment(today);
                  var b = Moment(date);
                  var dateF = a.diff(b, 'days') // 1
                  this.setState({ lastOrder : dateF+' days ago' , isDate : true})
                }
              }
        }

        if(props.getAllOrders){

          if( props.getAllOrders.orderList !== undefined &&
              props.getAllOrders.orderList.data !== undefined &&
              props.getAllOrders.orderList.data.data !== undefined) {
                this.setState({ currentOrder : props.getAllOrders.orderList.data.data });
              }

        }
    }
    //-- It will toggle
    toggleAccordion(tab) {
        const prevState = this.state.accordion;
        const state = prevState.map((x, index) => tab === index ? !x : false);
        this.setState({
            accordion: state,
        });
    }


    // popup for edit address
    editaddress = (address) => {
        if( address.locations !== undefined && address.locations.length>0){

            let setted = '';
            address.locations.map((add, index)=>{
                if(add.activeAddress === 'Yes') {return  setted = index; }
            });

            this.setState({ editAddressPopup : true, userData : address, defaultAddress : setted})

        }
    }

    handleCloseEditAddress = () => {
        this.setState({ editAddressPopup : false, userData : '', defaultAddress : ''});
    }

    changeAdress = (index) => {
       this.setState({ defaultAddress : index })
    }


    updateDefaultAddress = () => {
        const { siteConstants } = this.props.language;
        const {userDetails} = this.state;
        const { dispatch } = this.props;

        this.setState({ triggerEditAddress : true});

        let obj = {};
        obj.userid = userDetails._id;
        obj.index  = this.state.defaultAddress;

        dispatch(userActions.setDefaultAddress(apiConstants.SET_DEFAULT_ADDRESS, obj));


    }

    render() {
        const {userDetails} = this.state;
        const { classes } = this.props;
        const { history } = this.props;

        const { siteConstants } = this.props.language;
        const options = { year: 'numeric', month: 'long', day: 'numeric' };

        const created_date = new Date(userDetails.created_date);
        const dob = new Date(userDetails.dob);

        let userRole = '';
        const arrLength = userDetails.role_type !== undefined && userDetails.role_type.length > 0 ? userDetails.role_type.length : 0;

        if (userDetails.role_type !== undefined && userDetails.role_type.length > 0) {
            userRole = userDetails.role_type.map((usr, index) => {
                if (arrLength - 1 == index) { return usr; }
                return `${usr}, `;
            });
        }

        return (
            <Fragment>
                <nav className="" aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                            <a href="/dashboard">{siteConstants.GEN_DASHBOARD}</a>
                        </li>
                        <li className="breadcrumb-item">
                            <a href="/users">{siteConstants.GEN_USERS}</a>
                        </li>
                        <li className="active breadcrumb-item" aria-current="page">
                            {siteConstants.LABEL_USER_DETAILS}
                        </li>
                        {/* <li style={{ paddingLeft: "730px" }}>
                            <a href="javascript:void(0)" className="darkLink"
                                onClick={() => this.props.backButton()}>{siteConstants.BTN_BACK}</a>
                        </li> */}
                    </ol>
                </nav>

                <div className="container-fluid">
                    <div className="d-sm-flex align-items-center justify-content-between mb-4 mt-2">
                        <div className="col-md-10">
                            <a href="javascript:void(0)" className="darkLink"
                                onClick={() => this.props.backButton()}><i class="fa fa-angle-left"></i> {siteConstants.BTN_BACK}</a>
                        </div>
                        {/* <div className="col-md-2" className="textAlignRight">
                            <a href="javascript:void(0)" className="darkLink">
                                <i class="fa fa-angle-left"></i>
                            </a>
                            &nbsp;&nbsp;
                            <a href="javascript:void(0)" className="darkLink">
                                <i class="fa fa-angle-right"></i>
                            </a>
                        </div> */}
                    </div>
                    <div className="row">
                        <div className="col-md-8">
                            <div className="row">
                                <div className="col-md-12">
                                    <Card className="mb-2">
                                        <CardHeader>
                                            <Row>

                                                <Col xs="6">                                                  
                                                    {
                                                     userDetails.profile_image !== undefined && userDetails.profile_image ?
                                                     <img src={ `${config.imgPath}` + '/'+userDetails.profile_image } style={{width:"50px", height : "50px", borderRadius: "50%", marginRight:"10px"}} /> : ''
                                                    }
                                                    <strong>{userDetails.firstname} {userDetails.lastname} </strong> <br />
                                                    {userDetails.locations && userDetails.locations.length > 0 && userDetails.locations.map( (addrs) => {
                                                        if(addrs.activeAddress == 'Yes') {
                                                            return `${addrs.street} ${addrs.city} ${addrs.state} ${addrs.country} ${addrs.zipcode}`;
                                                        }
                                                    }) }<br />

                                                Joined from: {created_date !== '' ? created_date.toLocaleString("en-US", options) : ''}
                                                </Col>
                                                <Col xs="6" style={{"text-align":"right"}}>
                                                    {userDetails.email} <br />
                                                    {userDetails.mobile_number}
                                                </Col>
                                            </Row>

                                        </CardHeader>
                                        <CardBody>
                                            <Row>
                                                <Col xs="4">
                                                    <FormGroup>
                                                        <Label>{siteConstants.ORDER_TOTAL_SPENT}</Label>
                                                        <div className="fontBold">{config.currencyCode}{this.state.totalPaid}</div>
                                                    </FormGroup>
                                                </Col>
                                                <Col xs="4">
                                                    <FormGroup>
                                                        <Label>{siteConstants.LAST_ORDER}</Label>
                                                        <div className="fontBold">{this.state.isDate === true ? this.state.lastOrder : "NA" }</div>
                                                    </FormGroup>
                                                </Col>
                                                <Col xs="4">
                                                    <FormGroup>
                                                        <Label>{siteConstants.AVERAGE_ORDER_VALUE}</Label>
                                                        <div className="fontBold">{config.currencyCode}{this.state.avgOrder}</div>
                                                    </FormGroup>
                                                </Col>

                                            </Row>
                                        </CardBody>
                                    </Card>
                                    <Card>
                                        <CardHeader>{siteConstants.ORDER_PLACED}</CardHeader>
                                        <CardBody>

                                        {
                                          this.state.currentOrder !== undefined &&
                                          this.state.currentOrder._id !== undefined ?
                                          <Fragment>
                                            <div className="row">
                                                <div className="col-md-8"> <a href={"order-details/"+this.state.currentOrder._id} className="nav-link">{siteConstants.LABEL_ORDER} #{this.state.currentOrder.orderNumber}</a></div>
                                                <div className="col-md-4"> {Moment(this.state.currentOrder.createdAt).format(config.FullDateFormat)} </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-12"> {config.currencyCode}{this.state.currentOrder.pricepaid} from <b>{this.state.currentOrder.shopInfo.title}</b> </div>
                                            </div>
                                          </Fragment>
                                          :
                                          "No Active order"

                                        }



                                            <div className="row">
                                                <div className="col-md-12" style={{ textAlign: "right" }}>
                                                {
                                                  this.state.userDetails !== undefined &&
                                                  this.state.userDetails._id !== undefined ?
                                                    <a href="javascript:void(0)" onClick={(e)=>history.push("/user-orders/"+this.state.userDetails._id)} className="nav-link">{siteConstants.GEN_VIEW_ALL_ORDER}</a>
                                                  : ""
                                                }

                                                </div>
                                            </div>

                                        </CardBody>
                                    </Card>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="row">
                                <div className="col-md-12">
                                    <Card>
                                        {/* <CardHeader>
                                                    <i className="fa fa-align-justify"></i> Collapse
                                                </CardHeader> */}
                                        <CardBody>
                                            <div id="accordion">
                                                <Card className="mb-2">
                                                    <CardHeader id="headingThree">
                                                        <div className="row">
                                                            <div className="col-md-9">
                                                                <a href="javascript:void(0)" block color="link" className="darkLink" onClick={() => this.toggleAccordion(2)} aria-expanded={this.state.accordion[2]} aria-controls="collapseThree">
                                                                    <i className="fa fa-align-justify"></i> Customer Overview
                                                                        </a>
                                                            </div>
                                                            {/*<div className="col-md-3">
                                                                <a href="javascript:void(0)">Edit</a>
                                                            </div>*/}
                                                        </div>
                                                    </CardHeader>
                                                    <Collapse isOpen={this.state.accordion[2]} data-parent="#accordion" id="collapseThree">
                                                        <CardBody>
                                                            <div className="row">
                                                                <div className="col-md-12">
                                                                    <div className="form-group">
                                                                        <strong>{siteConstants.LABEL_FIRST_NAME}</strong>
                                                                        <input
                                                                            className="form-control"
                                                                            name="firstname"
                                                                            placeholder={siteConstants.LABEL_FIRST_NAME}
                                                                            value={userDetails.firstname}
                                                                            disabled="true"
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-md-12">
                                                                    <div className="form-group">
                                                                        <strong>{siteConstants.LABEL_LAST_NAME}</strong>
                                                                        <input
                                                                            className="form-control"
                                                                            name="firstname"
                                                                            placeholder={siteConstants.LABEL_LAST_NAME}
                                                                            value={userDetails.lastname}
                                                                            disabled="true"
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="row">
                                                                <div className="col-md-12">
                                                                    <div className="form-group">
                                                                        <strong>{siteConstants.LABEL_EMAIL}</strong>
                                                                        <input
                                                                            className="form-control"
                                                                            name="firstname"
                                                                            placeholder={siteConstants.LABEL_EMAIL}
                                                                            value={userDetails.email}
                                                                            disabled="true"
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-md-12">
                                                                    <div className="form-group">
                                                                        <strong>{siteConstants.LABEL_CONTACT_NO}</strong>
                                                                        <input
                                                                            className="form-control"
                                                                            name="firstname"
                                                                            placeholder={siteConstants.LABEL_CONTACT_NO}
                                                                            value={userDetails.mobile_number}
                                                                            disabled="true"
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>


                                                            <div className="row">
                                                                <div className="col-md-12">
                                                                    <div className="form-group">
                                                                        <strong>{siteConstants.LABEL_DOB}</strong>
                                                                        <input
                                                                            className="form-control"
                                                                            name="firstname"
                                                                            placeholder={siteConstants.LABEL_DOB}
                                                                            value={dob !== '' ? dob.toLocaleString("en-US", options) : ''}
                                                                            disabled="true"
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </CardBody>
                                                    </Collapse>
                                                </Card>

                                                {/*<Card className="mb-2">
                                                    <CardHeader id="headingTwo">

                                                        <div className="row">
                                                            <div className="col-md-9">
                                                                <a href="javascript:void(0)" block color="link" className="darkLink" onClick={() => this.toggleAccordion(1)} aria-expanded={this.state.accordion[1]} aria-controls="collapseTwo">
                                                                    <i className="fa fa-align-justify"></i> Default Address
                                                                        </a>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <a href="javacript:void(0)" onClick={(e)=>this.editaddress(userDetails)}>Manage</a>
                                                            </div>
                                                        </div>
                                                    </CardHeader>
                                                    <Collapse isOpen={this.state.accordion[1]} data-parent="#accordion" id="collapseTwo">
                                                        <CardBody>
                                                            {
                                                            userDetails.location && userDetails.locations.length > 0 && userDetails.locations.map( (addrs) => {
                                                                if(addrs.activeAddress == 'Yes') {
                                                                    return `${addrs.street} ${addrs.city} ${addrs.state} ${addrs.country} ${addrs.zipcode}`;
                                                                }
                                                            })
                                                            }
                                                        </CardBody>
                                                    </Collapse>
                                                </Card> */}


                                                {/* <Card className="mb-2">
                                                    <CardHeader id="headingThree">

                                                        <div className="row">
                                                            <div className="col-md-8">
                                                                <a href="javascript:void(0)" block color="link" className="darkLink" onClick={() => this.toggleAccordion(3)} aria-expanded={this.state.accordion[3]} aria-controls="collapseThree">
                                                                    <i className="fa fa-align-justify"></i> Other Address
                                                                        </a>
                                                            </div>
                                                            <div className="col-md-4">
                                                                <a href="#">Manage</a>
                                                            </div>
                                                        </div>
                                                    </CardHeader>
                                                    <Collapse isOpen={this.state.accordion[3]} data-parent="#accordion" id="collapseThree">
                                                        <CardBody>
                                                            {
                                                            userDetails.locations.length > 0 && userDetails.locations.map( (addrs) => {
                                                                if(addrs.activeAddress !== 'Yes') {
                                                                    return <div>
                                                                                <h4>{addrs.addressType}</h4>
                                                                                <p>{addrs.street+" "+addrs.city+" "+addrs.state+" "+addrs.country+" "+addrs.zipcode}</p>
                                                                           </div>
                                                                }
                                                            })
                                                            }
                                                        </CardBody>
                                                    </Collapse>
                                                </Card> */}



                                            </div>
                                        </CardBody>
                                    </Card>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <!-- /.container-fluid --> */}

                {/* edit address */}
                <Dialog
                        open={this.state.editAddressPopup}
                        aria-labelledby="edit-address"
                        aria-describedby="edit-address"
                    >
                        <DialogTitle className={classes.root}>{siteConstants.LABEL_POPUP_LABLE}</DialogTitle>
                        <DialogContent  className={classes.contentRoot}>
                        <div className="col-md-12 col-xs-12">
                           <div className="form-group">
                                <label>{siteConstants.LABEL_EDIT_DEFAULT_ADDRESS}</label>

                                   {
                                        this.state.userData!== undefined &&
                                        this.state.userData.locations !== undefined &&
                                        this.state.userData.locations.map( (addrs, index) => {
                                            let checked = '';
                                            if( this.state.defaultAddress !== undefined &&
                                                this.state.defaultAddress !== '' &&
                                                this.state.defaultAddress === index
                                                ){
                                                    checked ='checked';
                                                }

                                        return <div>
                                                    <h4> <input type="radio" checked={checked} onChange={(e)=>this.changeAdress(index)}/> {addrs.addressType}</h4>
                                                    <p>{addrs.street+" "+addrs.city+" "+addrs.state+" "+addrs.country+" "+addrs.zipcode}</p>
                                                </div>

                                        })
                                    }

                            </div>
                        </div>

                        </DialogContent>
                        <DialogActions>
                            <Button variant="contained" onClick={()=>this.handleCloseEditAddress()}>{siteConstants.LABEL_CANCEL}</Button>
                            <Button variant="contained" color="primary" onClick={ (e) => this.updateDefaultAddress(e) }>{siteConstants.LABEL_SAVE}</Button>
                        </DialogActions>
                    </Dialog>
            </Fragment>
        );
    }
}

//-- Here we are adding Reducer names, so it can be get data from reducers using store
function mapStateToProps(state) {
    const { language, setDefaultAddress, updatedAccountDetails, getAllOrders } = state;
    return {
        language, setDefaultAddress, updatedAccountDetails, getAllOrders
    };
}

// const connectedUsersDetail = connect(mapStateToProps)(UsersDetail);
// export default connectedUsersDetail;

export default connect(mapStateToProps)(withStyles(styles)(UsersDetail));
